import { LineType } from "@/components/FlowSheetEditor/constant"
import { Edge } from "@antv/x6"
import { edgeToLineRecord } from "@/components/FlowSheetEditor/services/storage"
import { LineUnitPanel } from "../UnitPanel/LineUnitPanel"
import { LinePanel } from "../BasicNodePanel/LinePane"

interface EdgeCellPanelProps {
  edge: Edge
}
export function EdgeCellPanel(props: EdgeCellPanelProps) {
  const {edge} = props
  const data = edge.getData()
  const edgeType = data.type;

  switch (edgeType) {
    case LineType.FlowLine: {
      const record = edgeToLineRecord(edge.toJSON())
      return <LineUnitPanel unit={record} />
    }
    case LineType.Line:
    case LineType.Template: {
      return <LinePanel unit={edge} />
    }
  
    default:
      break;
  }
}